/* eslint-disable global-require */
import React from 'react';
import { FlashMessageContainer } from '@pegasus/ui-flashmessages/components/flashmessages';

import { Spacer } from '@pegasus/ui-headers/components/Spacer';
import { HeaderWrapper } from '../../shared/header';
import { useCustomerInfoWithPrefetch } from '../../shared/CustomerInfo/redux/hooks';
import { SideMenu } from '../SideMenu';
import { BackToTop } from '../shared/BackToTop';
import { ChatBoxContainer } from '../shared/ChatBoxContainer';
import { useFlashMessagesWithPrefetch } from '../../shared/flash-messages/redux/hooks';
import { FooterWrapper } from '../../shared/footer/wrapper';

import { TranslateScope } from '@pegasus/translation/components';

import {
    Body,
    Wrapper,
    ChildrenWrapper,
    FixedButtonsWrapper,
    FlashMessageContainerWrapper,
} from './Core.styles';

interface Props {
    children: React.ReactNode;
}

export const CoreWebLayout = ({ children }: Props) => {
    const messages = useFlashMessagesWithPrefetch();
    useCustomerInfoWithPrefetch();

    return (
        <>
            <TranslateScope>
                <HeaderWrapper />
                <Spacer />
            </TranslateScope>
            <FlashMessageContainerWrapper>
                <Spacer />
                <FlashMessageContainer messages={messages} />
            </FlashMessageContainerWrapper>
            <Body>
                <Wrapper>
                    <SideMenu />
                    <ChildrenWrapper>{children}</ChildrenWrapper>
                    <FixedButtonsWrapper>
                        <ChatBoxContainer />
                        <BackToTop />
                    </FixedButtonsWrapper>
                </Wrapper>
            </Body>
            <TranslateScope>
                <FooterWrapper />
            </TranslateScope>
        </>
    );
};
